const dropCatalog = function () {
  const dropMenuButtonCatalog = document.querySelectorAll(
    '.side-lvl-two__toggle',
  );

  dropMenuButtonCatalog.forEach((el) => {
    if (!el.classList.contains('render')) {
      el.classList.toggle('render');
      el.addEventListener('click', () => {
        el.parentNode.classList.toggle('_active');
      });
    }
  });
};

dropCatalog();
window.dropCatalogInit = dropCatalog;
